<template>
  <div class="single-histogram">
    <!-- -->
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'SingleHistogram',
  props:{
    data:{
      type:Object,
      default:null
    },
    xAxis:{
      type:Object,
      default: null
    },
    yAxis:{
      type:Object,
      default:null
    },
    max:{
      type:Number,
      default:100
    },
  },
  data() {
    return {
      chartProps:{},
      xAxis_:{},
      yAxis_:{},
      series_:{}
    };
  },
  created(){
    const colorArr= ['#0C628C', '#3887D5', '#2570BB']
    const color = {
      type: 'linear',
      x: 0,
      x2: 1,
      y: 0,
      y2: 0,
      colorStops: [
        {
          offset: 0,
          color: colorArr[0]
        },
        {
          offset: 0.5,
          color: colorArr[0]
        },
        {
          offset: 0.5,
          color: colorArr[1]
        },
        {
          offset: 1,
          color: colorArr[1]
        }
      ]
    }
    const barWidth = 30
    this.xAxis_ = Object.assign({
      name: 'X轴',
      data:[this.data.xData],
      show:true,
      axisLabel:{
        padding:[5,5,5,5],
        color:'#000',
        backgroundColor:'#fff'
      },
      axisTick: { // X轴线 刻度线 
        show: false,
      },
      axisLine: {
        show: false, // 不显示坐标轴线
      },
      splitLine:{
        show:false // 不显示网格线
      },
    },this.xAxis)
    this.yAxis_ = Object.assign({
      name:'Y轴',
      max:this.max,
      show:false
    },this.yAxis)

    const style3d = [
    {
      name: '',
      type: 'pictorialBar',
      symbolOffset: ['0%', '50%'],
      symbolSize: [barWidth - 4, (10 * (barWidth - 4)) / barWidth],
      z: 12,
      symbol: 'diamond',
      itemStyle: {
          opacity: 1,
          color: color
          // color: 'transparent'
      },
      data: [1]
  },
  // 数据的柱状图
  {
      name: '数据',
      type: 'bar',
      barWidth: barWidth,
      itemStyle: {
          // lenged文本
          opacity: 1, // 这个是 透明度
          color: color
      },

      data: [this.data.yData]
  },
  // 替代柱状图 默认不显示颜色，是最下方柱图的value值 - 20
  {
      type: 'bar',
      symbol: 'diamond',
      barWidth: barWidth + 2,
      itemStyle: {
          color: 'transparent'
      },
      data: [this.data.yData]
  },
  // 数据顶部的样式
  {
      name: '',
      type: 'pictorialBar',
      symbol: 'diamond',
      symbolOffset: ['0%', '-50%'],
      symbolSize: [barWidth, 10],
      z: 12,
      itemStyle: {
        opacity: 1,
        color: colorArr[2],
        
      }, 
      symbolPosition: 'end',
      data: [this.data.yData]
  },

  // 阴影的顶部
  {
      name: '', // 头部
      type: 'pictorialBar',
      symbol: 'diamond',
      symbolOffset: ['0%', '-50%'],
      symbolSize: [barWidth, 10],
      z: 12,
      symbolPosition: 'end',
      itemStyle: {
          color: 'blue',
          opacity: 0.3,
          borderWidth: 1,
          borderColor: 'rgba(18, 47, 133,1)'
      },
      data: [this.data.yData]
  },
  // 后面的背景
  {
      name: '',
      type: 'bar',
      barWidth,
      barGap: '-100%',
      z: 0,
      itemStyle: {
          color: 'rgba(18, 47, 133,0.3)'
      },
      label: {
        show: true, // 开启显示
        position: 'top', // 在上方显示
        textStyle: {
          // 数值样式
          color: '#FFFFFF',
          fontSize: 12,
          top: 0,
        }
      },
      data: [this.data.yData]
  }
    ]

    this.series_ =[{
      name: '数据',
      type: 'bar',
      data: [this.data.yData],
      
    },...style3d]

    this.chartProps = {
      color: ['#c23531',],
      grid:{
        top:'20px',
        left:'0px',
        right:'0px',
        bottom:'25px',
        // containLabel:true
      },
      tooltip: {
        trigger: 'none',
        axisPointer: {
          type: 'shadow'
        }
      },
      xAxis: this.xAxis_,
      yAxis: this.yAxis_,
      series: this.series_
    };
  },
  mounted() {
    this.initChart()
  },

  methods: {
    initChart(){
      var myChart = echarts.init(this.$el);
      myChart.setOption(this.chartProps);
      myChart.on('click',()=>{
        this.$emit('chart-click')
      })
    },
  },
};
</script>

<style scoped>
.single-histogram{
  width: 100px;
  height: 100px;
  /* background-color: white; */
}
</style>